import { Helmet } from 'react-helmet-async';

function Head() {
  return (
    <Helmet>
      <title>ESIMPRO | Impro y teatro en Berlín</title>
      <meta name="description" content="Compañía y escuela de Artes escénicas en Berlín, un espacio intercultural donde formamos personas y a empresas." />
    </Helmet>
  );
}

export default Head;
